const TooltipTypes = {
    neut: {
        imagePath: null,
        textDescription: "Kies een neut uit de dropdownlijst om hier een tekening met maten te zien."
    },
    sponningmaat: {
        imagePath: null,
        textDescription: "Wilt u een andere maat laat ons dit dan weten in de opmerkingen."
    }
}

export default TooltipTypes;